import {Utils} from "../../../shared/utils/utils";
import {SecuritySchedule} from "./security-schedule";

export class SecurityScheduleMapper {

  public static map(data: any): SecuritySchedule {
    const scheduleData: any = data && data.cron ? data.cron : data;

    const securitySchedule: SecuritySchedule = new SecuritySchedule();

    securitySchedule.schedule = scheduleData && Utils.isTruthy(scheduleData.schedule);
    securitySchedule.expression = scheduleData && scheduleData.expression;

    return securitySchedule;
  }

  public static generateRequestData(data: any): any {
    const securityScheduleData: any = {
      'name': 'cron',
      'settings': {
        'schedule': data.schedule ? '1' : '0',
        'expression': data.expression,
      }
    };

    return securityScheduleData;
  }

  public static mapResponseData(data: any): any {
    const securityScheduleData: any = {
      'cron': {
        'schedule': data.schedule ? '1' : '0',
        'expression': data.expression,
      }
    };

    return securityScheduleData;
  }

}
